import { render, staticRenderFns } from "./SeeDetail.vue?vue&type=template&id=4ca887b0&scoped=true&"
import script from "./SeeDetail.vue?vue&type=script&lang=ts&"
export * from "./SeeDetail.vue?vue&type=script&lang=ts&"
import style0 from "./SeeDetail.vue?vue&type=style&index=0&id=4ca887b0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ca887b0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCardTitle,VCol,VDialog,VImg,VRow})
